import React, { Component } from 'react'
import Button from "../../components/Button"
import { Link } from "react-router-dom"
import './css/startjourney.css'

class startjourney extends Component {
    render() {
        return (
            <div className="startjourney">
                <h1>Ready to start your journey in the <br /> forex market?</h1>
                <div className="button">
                    <Link to="/academy">
                        <Button className="gta-button">Go to Academy</Button>
                    </Link>
                </div>
            </div>  
        )
    }
}

export default startjourney;